import { ReferenceNumberStatus } from 'api'

export const referenceNotAllowedStatuses = [ReferenceNumberStatus.Closed, ReferenceNumberStatus.Voided]
